(function () {
  'use strict';

  // ─── Media Alt Helper ────────────────────────────────────────────────────────

  function getAlt(item) {
    const inner = item.querySelector('.m-product-media[data-media-alt]');
    return inner ? (inner.dataset.mediaAlt || '').toLowerCase().trim() : '';
  }

  // ─── Image / Media Filtering ─────────────────────────────────────────────────

  function filterMedia(keyword) {
    const section = document.querySelector('[data-section-type="product-page"]');
    if (!section) return;

    const lowerKeyword = keyword.toLowerCase().trim();

    const desktopItems = [...section.querySelectorAll('.m-product-media--list .m-product-media--item')];
    const mobileSlides = [...section.querySelectorAll(
      '.m-product-media--slider__images .swiper-slide.m-product-media--item:not(.swiper-slide-duplicate)'
    )];
    const thumbSlides  = [...section.querySelectorAll('.m-product-media--slider__thumbnails .swiper-slide')];
    const dupeSlides   = [...section.querySelectorAll(
      '.m-product-media--slider__images .swiper-slide.m-product-media--item.swiper-slide-duplicate'
    )];

    const allReal = [...desktopItems, ...mobileSlides];
    const hasAnyMatch = allReal.some(item => {
      const alt = getAlt(item);
      return alt && alt.includes(lowerKeyword);
    });

    function shouldShow(item) {
      if (!hasAnyMatch) return true;
      const alt = getAlt(item);
      if (!alt) return false;
      return alt.includes(lowerKeyword);
    }

    desktopItems.forEach(item => {
      item.dataset.variantHidden = shouldShow(item) ? 'false' : 'true';
    });

    mobileSlides.forEach(slide => {
      slide.dataset.variantHidden = shouldShow(slide) ? 'false' : 'true';
    });

    dupeSlides.forEach(dupe => {
      const mediaId = dupe.dataset.mediaId;
      const original = section.querySelector(
        `.m-product-media--slider__images .swiper-slide.m-product-media--item:not(.swiper-slide-duplicate)[data-media-id="${mediaId}"]`
      );
      dupe.dataset.variantHidden = original ? original.dataset.variantHidden : 'false';
    });

    thumbSlides.forEach(thumb => {
      const inner = thumb.querySelector('.m-product-media[data-media-alt]');
      const alt   = inner ? (inner.dataset.mediaAlt || '').toLowerCase().trim() : '';
      thumb.style.display = (!hasAnyMatch || (alt && alt.includes(lowerKeyword))) ? '' : 'none';
    });

    jumpToFirstVisible(section, mobileSlides);
  }

  function jumpToFirstVisible(section, mobileSlides) {
    const swiperEl = section.querySelector('.m-product-media--slider__images .swiper-container');
    if (!swiperEl || !swiperEl.swiper) return;
    const firstVisibleIndex = mobileSlides.findIndex(s => s.dataset.variantHidden !== 'true');
    if (firstVisibleIndex >= 0) {
      swiperEl.swiper.slideTo(firstVisibleIndex, 0, false);
    }
  }

  // ─── Variant Resolution Helpers ──────────────────────────────────────────────

  function getSelectedValues(picker) {
    const values = [...picker.querySelectorAll('input[type="radio"]:checked')].map(r => r.value);
    if (!values.length) {
      picker.querySelectorAll('select').forEach(sel => {
        if (sel.value) values.push(sel.value);
      });
    }
    return values;
  }

  function resolveVariant(variants, selectedValues) {
    return variants.find(v => selectedValues.every(val => v.options.includes(val)));
  }

  function getVariants() {
    const el = document.querySelector('#productVariants');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getInitialValue() {
    const checked = document.querySelector('variant-picker input[type="radio"]:checked');
    if (checked) return checked.value;
    const sel = document.querySelector('variant-picker select');
    if (sel && sel.value) return sel.value;
    return null;
  }

  // ─── Variant Video and image Player ────────────────────────────────────────────────────
function applyVariantVideo(variantId) {
  const dataEl = document.querySelector('[id^="variantVideoData-"]');
  if (!dataEl) return;

  let videoMap;
  try { videoMap = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const player = document.querySelector('.m-variant-video-player');
  if (!player) return;

  const entry = videoMap[String(variantId)] || {};
  let videoUrl = entry.video || '';
  let imageUrl = entry.image || '';

  // Unwrap arrays just in case
  if (Array.isArray(videoUrl)) videoUrl = videoUrl[0] || '';
  if (Array.isArray(imageUrl)) imageUrl = imageUrl[0] || '';

  videoUrl = String(videoUrl).trim();
  imageUrl = String(imageUrl).trim();

  const videoEl = player.querySelector('video');
  const source  = videoEl && videoEl.querySelector('source');
  const imageEl = player.querySelector('.m-variant-video-player__image');

  const hasVideo = !!videoUrl;
  const hasImage = !!imageUrl;

  // --- Video ---
  if (hasVideo && source) {
    if (source.getAttribute('src') !== videoUrl) {
      source.setAttribute('src', videoUrl);
      videoEl.load();
    }
    videoEl.play().catch(() => {});
    videoEl.style.display = 'block';
  } else {
    if (videoEl) {
      videoEl.style.display = 'none';
      videoEl.pause();
    }
  }

  // --- Image ---
  if (hasImage && imageEl) {
    if (imageEl.getAttribute('src') !== imageUrl) {
      imageEl.setAttribute('src', imageUrl);
    }
    imageEl.style.display = 'block';
  } else {
    if (imageEl) imageEl.style.display = 'none';
  }

  // --- Show/hide the container ---
  player.style.display = (hasVideo || hasImage) ? 'block' : 'none';
}
  function initVariantVideo() {
    const variants = getVariants();
    if (!variants) return;

    const picker = document.querySelector('variant-picker');
    if (!picker) return;

    const selectedValues = getSelectedValues(picker);
    const selected = resolveVariant(variants, selectedValues) || variants[0];
    if (selected) applyVariantVideo(selected.id);
  }

  function updateVariantVideo(input) {
    const picker = input.closest('variant-picker');
    if (!picker) return;

    const variants = getVariants();
    if (!variants) return;

    const selectedValues = getSelectedValues(picker);
    const matched = resolveVariant(variants, selectedValues);
    if (matched) applyVariantVideo(matched.id);
  }

  // ─── Init ────────────────────────────────────────────────────────────────────

  function init() {
    // Single change listener handles both image filtering and video switching
    document.addEventListener('change', (e) => {
      if (!e.target.closest('variant-picker')) return;
      if (e.target.type !== 'radio' && e.target.tagName !== 'SELECT') return;

      filterMedia(e.target.value);
      updateVariantVideo(e.target);
    });

    // Page load — run immediately then again after Swiper initialises
    const initial = getInitialValue();
    if (initial) {
      filterMedia(initial);
      updateVariantVideo({ closest: () => document.querySelector('variant-picker') });
    }

    setTimeout(() => {
      if (initial) filterMedia(initial);
      initVariantVideo();
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();